module.exports = __webpack_public_path__ + "static/media/contentIntroductionMobile1.98dc1721.png";